import RewardsApi from "../api/RewardsApi";
import * as queryString from "querystring";
import {CancelToken} from "axios";

export default class CustomerOffersService {
    static itemsPerPage: number = 5;

    static getCurrentCustomerOffers = (ticket: string, locale: string) => {
        let data = {
            locale: locale,
            limit: CustomerOffersService.itemsPerPage,
        };

        return RewardsApi.get(
            `/v1/offers?${queryString.stringify(data)}`,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Authorization': `ubi_v1 t=${ticket}`
                }
            }
        );
    };

    static getCustomerOffer = (
        ticket: string,
        locale: string,
        period: "previous" | "current" | "upcoming",
        ruleId: number,
        cancelToken?: CancelToken
    ) => {
        let data = {
            locale: locale,
            period: period,
            ruleId: ruleId,
            limit: 1,
            offset: 0,
        };

        return RewardsApi.get(
            `/v1/offers?${queryString.stringify(data)}`,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Authorization': `ubi_v1 t=${ticket}`
                },
                cancelToken: cancelToken
            }
        );
    };
}